export default __webpack_public_path__ + "media/images/banners/bnr_island-4cf5b8e2cd45ea48810b53dcf75eed5d.png";